document.addEventListener("DOMContentLoaded", async () => {
    const anchorEl = document.querySelectorAll(".handle-anchor");
    if (anchorEl) {
        const { initAnchorLink } = await import("../components/anchorlink.js");
        initAnchorLink(false);
    }
    const handleAccordion = document.querySelectorAll(".handle-accordion");
    if (handleAccordion.length > 0) {
        const { initAccordionHoverControl } = await import('../components/accordion.js');
        initAccordionHoverControl();
            let timeout;
            window.addEventListener("resize", function () {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    initAccordionHoverControl();
                }, 300);
            });

    }

    const { disableContextImage } = await import("../components/detect-image.js");
    disableContextImage("#news-list");
});
